import React from 'react'

const BetterShippingRates = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 780 780"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#ffce33"
                        d="M482.286 482.424c-61.229 0-118.794-23.844-162.09-67.141-43.296-43.296-67.141-100.861-67.141-162.09 0-61.23 23.844-118.796 67.14-162.094C363.492 47.8 421.057 23.955 482.286 23.955c61.232 0 118.799 23.846 162.097 67.144 43.297 43.298 67.141 100.864 67.141 162.094s-23.845 118.795-67.142 162.091c-43.296 43.296-100.863 67.14-162.096 67.14z"
                        opacity={1}
                        data-original="#ffce33"
                        className=""
                    />
                    <path
                        fill="#ffffff"
                        d="M637.756 253.192c0 85.86-69.604 155.464-155.469 155.464-85.86 0-155.464-69.604-155.464-155.464S396.428 97.723 482.287 97.723c85.865 0 155.469 69.61 155.469 155.469z"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#ff9d00"
                        d="M482.286 489.925c-63.233 0-122.681-24.625-167.394-69.338-44.713-44.712-69.337-104.161-69.337-167.394s24.625-122.682 69.337-167.397c44.713-44.715 104.161-69.341 167.394-69.341 63.235 0 122.686 24.625 167.4 69.341 44.713 44.714 69.338 104.164 69.338 167.397s-24.625 122.682-69.338 167.394c-44.714 44.713-104.165 69.338-167.4 69.338zm0-458.47c-59.226 0-114.907 23.065-156.787 64.947-41.879 41.882-64.944 97.564-64.944 156.791s23.064 114.908 64.944 156.787c41.879 41.88 97.561 64.944 156.787 64.944 59.228 0 114.912-23.064 156.793-64.944 41.88-41.879 64.945-97.561 64.945-156.788S680.96 138.282 639.08 96.401c-41.881-41.88-97.565-64.946-156.794-64.946z"
                        opacity={1}
                        data-original="#ff9d00"
                        className=""
                    />
                    <g fill="#fff">
                        <path
                            d="M482.287 416.156c-89.858 0-162.964-73.105-162.964-162.964 0-89.861 73.105-162.969 162.964-162.969 89.861 0 162.969 73.107 162.969 162.969 0 89.859-73.108 162.964-162.969 162.964zm0-310.933c-81.587 0-147.964 66.378-147.964 147.969 0 81.587 66.376 147.964 147.964 147.964 81.59 0 147.969-66.376 147.969-147.964 0-81.59-66.379-147.969-147.969-147.969z"
                            fill="#ffffff"
                            opacity={1}
                            data-original="#ffffff"
                        />
                        <path
                            d="M482.29 105.223a7.5 7.5 0 0 1-7.5-7.5V73.627a7.5 7.5 0 0 1 15 0v24.097a7.5 7.5 0 0 1-7.5 7.499zM482.29 440.253a7.5 7.5 0 0 1-7.5-7.5v-24.097a7.5 7.5 0 0 1 15 0v24.097a7.5 7.5 0 0 1-7.5 7.5zM390.915 134.915a7.49 7.49 0 0 1-6.074-3.092l-14.164-19.495a7.5 7.5 0 1 1 12.136-8.816l14.164 19.495a7.5 7.5 0 0 1-6.062 11.908zM587.841 405.96a7.49 7.49 0 0 1-6.074-3.092l-14.164-19.495a7.5 7.5 0 1 1 12.135-8.817l14.164 19.495a7.5 7.5 0 0 1-6.061 11.909zM334.434 212.65a7.499 7.499 0 0 1-2.319-.369l-22.917-7.446a7.499 7.499 0 0 1-4.815-9.45 7.498 7.498 0 0 1 9.45-4.815l22.917 7.446a7.502 7.502 0 0 1-2.316 14.634zM653.066 316.18a7.499 7.499 0 0 1-2.319-.369l-22.917-7.446a7.499 7.499 0 0 1-4.815-9.45 7.498 7.498 0 0 1 9.45-4.815l22.917 7.446a7.499 7.499 0 0 1 4.815 9.45 7.503 7.503 0 0 1-7.131 5.184zM311.514 316.18a7.501 7.501 0 0 1-2.316-14.635l22.917-7.446a7.498 7.498 0 0 1 9.45 4.815 7.5 7.5 0 0 1-4.815 9.45l-22.917 7.446a7.47 7.47 0 0 1-2.319.37zM630.146 212.65a7.501 7.501 0 0 1-2.316-14.635l22.917-7.446a7.498 7.498 0 0 1 9.45 4.815 7.5 7.5 0 0 1-4.815 9.45l-22.917 7.446c-.77.252-1.551.37-2.319.37zM376.739 405.96a7.5 7.5 0 0 1-6.062-11.909l14.164-19.495a7.5 7.5 0 0 1 12.136 8.816l-14.164 19.495a7.49 7.49 0 0 1-6.074 3.093zM573.664 134.915a7.5 7.5 0 0 1-6.061-11.909l14.164-19.495a7.5 7.5 0 0 1 10.476-1.659 7.5 7.5 0 0 1 1.659 10.476l-14.164 19.495a7.49 7.49 0 0 1-6.074 3.092z"
                            fill="#ffffff"
                            opacity={1}
                            data-original="#ffffff"
                        />
                    </g>
                    <path
                        fill="#0e4089"
                        d="M216.866 754.753c.105-.068.212-.134.321-.196 12.144-7.016 16.316-22.603 9.301-34.746L120.459 536.272c-3.398-5.882-8.884-10.089-15.447-11.846a25.272 25.272 0 0 0-19.146 2.458L61.3 542.771c-.106.069-.216.125-.324.187l131.47 227.587z"
                        opacity={1}
                        data-original="#0e4089"
                    />
                    <path
                        fill="#fcb765"
                        d="m287.923 678.045 155.656 64.708c11.701 4.864 24.732 4.07 35.755-2.176L685.217 623.91c17.187-9.739 23.913-31.298 15.315-49.082-4.533-9.375-12.491-16.282-22.41-19.451s-20.408-2.155-29.536 2.855l-117.898 64.71c.306 6.112-.725 12.269-3.108 18.109-6.665 16.334-22.65 26.341-39.409 26.341a41.825 41.825 0 0 1-15.173-2.845l-117.013-45.432a7.502 7.502 0 0 1 5.429-13.984l117.013 45.433c13.838 5.374 29.657-1.437 35.265-15.181 1.969-4.823 2.509-9.981 1.638-14.985-.028-.126-.048-.252-.069-.379a27.638 27.638 0 0 0-1.725-5.703c-2.881-6.772-8.233-12-15.071-14.722L292.764 517.72a58.13 58.13 0 0 0-47.912 2.229l-89.978 45.91 73.32 126.918 25.276-13.218a40.556 40.556 0 0 1 34.453-1.514z"
                        opacity={1}
                        data-original="#fcb765"
                        className=""
                    />
                    <path
                        fill="#4f6d8f"
                        d="m527.058 607.824 1.102-.605-1.696-.701c.208.429.4.868.594 1.306z"
                        opacity={1}
                        data-original="#4f6d8f"
                    />
                    <g fill="#ff9d00">
                        <path
                            d="M539.164 330.499a7.47 7.47 0 0 1-4.256-1.33l-86.452-59.723a7.5 7.5 0 0 1 4.263-13.671c21.777 0 39.494-17.717 39.494-39.493 0-21.777-17.717-39.494-39.494-39.494-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5c30.048 0 54.494 24.446 54.494 54.494 0 23.343-14.753 43.305-35.425 51.051l71.646 49.494a7.5 7.5 0 0 1-4.27 13.672z"
                            fill="#ff9d00"
                            opacity={1}
                            data-original="#ff9d00"
                            className=""
                        />
                        <path
                            d="M539.171 176.788h-91.828c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h91.828c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5zM539.171 223.782h-91.828c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h91.828c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z"
                            fill="#ff9d00"
                            opacity={1}
                            data-original="#ff9d00"
                            className=""
                        />
                    </g>
                </g>
            </svg>

        </>
    )
}

export default BetterShippingRates